const getHeaders = (getState) => {
  const { session } = getState().userReducer;
  return {
    Authorization: `Bearer ${session?.token}`,
    "Content-Type": "application/json",
  };
};

export { getHeaders };
